import { Button, Col, Row, notification } from "antd";
import React, { useEffect, useState } from "react";
import api from "../../services/api";


export default function SincronizarCatalogo() {

    function iniciarSincronização() {
        api.post("Siger/Sincronizar").then(
            res => {
                notification.success({ message: "SUUUU CESSO" })
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    }

    return (<div>
        <Row>
            <Col>
                <Button size="large" type="primary" onClick={iniciarSincronização}>Sincronizar Agora</Button>
            </Col>
        </Row>
    </div>);
}